module.exports = __webpack_public_path__ + "img/logout-icon.3ef5ebe7.svg";